import { USER_ACTION, USER_ACTION_ADD } from '../types';

export const userReducer = (state = {
    details: {
        token: undefined,
        name: '',
        role: '',
        type: '',
        event: '',
        passKey: '',
        details: {},
        location: {},
        date: '',
        storyImage: '',
        eventType: '',
        phone: '',
        eventsBeingProcessed: [],
        events: []
    }
}, action) => {
    switch (action.type) {
        case USER_ACTION:
            return {
                ...state,
                details: action.payload,
            };
        case USER_ACTION_ADD:
            return {
                ...state,
                details: {
                    ...state.details,
                    ...action.payload
                }
            };
        default:
            return state;
    }
};

